import { Injectable } from '@angular/core';
import { List as ImmutableList } from 'immutable';
import { ModuleAccessLevel } from '../../constants-types/Enums';
import { List } from '../../constants-types/PiList.model';
import {
    ModuleAccessConfiguration,
    ModuleAccountType,
    ModuleExperienceType,
    SoftwareModuleAccessConfiguration,
    SoftwareModuleAccessRUMConfiguration,
    ValueMetricLimitOld
} from '../../core-data-model/ModuleAccess/ModuleAccess.model';
import {
    SoftwareModuleAccessConfigurationServer,
    ValueMetricLimitServerOld
} from '../../core-data-model/ModuleAccess/ModuleAccess.serverinterface';

@Injectable({ providedIn: 'root' })
export class ModuleAccessTransformer {
    configServerToClient(
        server: SoftwareModuleAccessConfigurationServer
    ): SoftwareModuleAccessConfiguration {
        const config = [];
        server.softwareModuleAccessConfig.forEach((m) => {
            const moduleAccessConfig: ModuleAccessConfiguration = {
                name: m.name,
                accessLevel: m.accessLevel || ModuleAccessLevel.NoAccess,
                valueMetrics: this.valueMetricsServerToClient(m.valueMetrics),
                timeTrials: m.timeTrials ?? ImmutableList([]),
                moduleExperienceType:
                    m.moduleExperienceType || ModuleExperienceType.Unknown,
                moduleAccountType:
                    m.moduleAccountType || ModuleAccountType.Unknown
            };
            config.push(moduleAccessConfig);
        });

        const softwareConfiguration: SoftwareModuleAccessConfiguration = {
            softwareModuleAccessConfig: config,
            accountClassification: server.accountClassification
        };

        return softwareConfiguration;
    }

    configureClientToRum(
        softwareModuleAccessConfig: Array<ModuleAccessConfiguration>
    ): SoftwareModuleAccessRUMConfiguration {
        const config = {};

        softwareModuleAccessConfig.forEach((service) => {
            config[service.name] = {
                accessLevel: ModuleAccessLevel[service.accessLevel],
                moduleAccountType: ModuleAccountType[service.moduleAccountType],
                moduleExperienceType:
                    ModuleExperienceType[service.moduleExperienceType]
            };
        });

        return {
            softwareModuleAccessRUMConfig: config
        };
    }

    private valueMetricsServerToClient(
        valueMetricsServer: List<ValueMetricLimitServerOld>
    ): List<ValueMetricLimitOld> {
        if (valueMetricsServer) {
            return valueMetricsServer.map((x) => ({
                name: x.name,
                limit: x.limit
            }));
        }
        return ImmutableList([]);
    }
}
